import React, { useEffect, useState } from "react";
import RouteModal from "../../../../Component/BasicComponents/Modal/RouteModal";
import CustomInput from "../../../../Component/BasicComponents/CustomInput";
import { Btn } from "../../../../AbstractElements";
import ReusableDropdown from "../../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import { useGetCurrencies, useGetOrgUnitsData } from "../hooks/useGradeMaster";
import { showToast } from "../../../../utils/toastUtils";

interface ModalProps {
  title?: string;
  isModalOpen: boolean;
  toggleModal: () => void;
  handleSubmit: (formData: any) => void;
  onCancilBtn: () => void;
  modalContentState?: string;

  selectedRowData?: any;
}

const CommonModalForNewPolicy: React.FC<ModalProps> = ({
  title,
  isModalOpen,
  toggleModal,
  handleSubmit,
  onCancilBtn,
  modalContentState,
  selectedRowData,
}) => {
  console.log(
    "🚀 ~ CommonModalForNewPolicy.tsx:30 ~ selectedRowData:",
    selectedRowData
  );

  const [formValues, setFormValues] = useState({
    policyid: "",
    name: "",
    shortcode: "",
    orgunit: "",
    currency: "",
    startdate: "",
    enddate: "",
  });

  const { data: currenciesData } = useGetCurrencies({ enable: true });
  const { data: orgUnitsData } = useGetOrgUnitsData({ enable: true });

  let formattedCurrenciesData = Object.entries(currenciesData?.data || {}).map(
    (item: any, index: any) => ({
      id: item[0],
      label: item[1],
    })
  );

  const formattedOrgUnitData = Object.entries(orgUnitsData?.data || {}).map(
    (item: any, index: any) => ({
      id: item[0],
      label: item[1],
    })
  );

  // Handle dropdown selection
  const handleDropdownSelect = (field: string, value: string | number) => {
    setFormValues((prevState) => ({
      ...prevState,
      [field]: value, // Directly assign the selected value
    }));
  };

  // Handle input changes
  const handleInputChange = (
    name: any,
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { value } = e.target;

    // Convert specific fields to numbers
    const numericFields = ["a", "b"];
    const updatedValue = numericFields.includes(name)
      ? value.replace(/[^0-9]/g, "") // Allow only numbers
      : value; // Keep string values as they are

    setFormValues((prevState) => ({
      ...prevState,
      [name]: numericFields.includes(name)
        ? updatedValue === ""
          ? ""
          : Number(updatedValue)
        : updatedValue,
    }));
  };

  useEffect(() => {
    if (
      (modalContentState === "Edit" || modalContentState === "View") &&
      selectedRowData
    ) {
      console.log(
        "🚀 ~ CommonModalForNewPolicy.tsx:87 ~ useEffect ~ selectedRowData:",
        selectedRowData
      );

      setFormValues({
        // name: selectedRowData?.Name || "",
        policyid: selectedRowData?.PolicyId,
        name: selectedRowData?.PolicyName,
        shortcode: selectedRowData?.PolicyCode,
        orgunit: selectedRowData?.OrgUnitId,
        currency: selectedRowData?.CurrencyId,
        startdate: selectedRowData?.StartDate,
        enddate: selectedRowData?.EndDate,
      });
    } else {
      setFormValues({
        policyid: "",
        name: "",
        shortcode: "",
        orgunit: "",
        currency: "",
        startdate: "",
        enddate: "",
      });
    }
  }, [modalContentState, selectedRowData]);

   const handleSubmitInsideChild=(formValues:any)=>{
      if(formValues.currency !="" && formValues.name !="" &&formValues.startdate !="" && formValues.enddate !="" && formValues.orgunit !="") {
        handleSubmit(formValues)
      }else{
        showToast.warning('Fill the Mendatory Filed');
      }
   }

  return (
    <RouteModal
      size="md"
      isOpen={isModalOpen}
      toggle={toggleModal}
      title={title}
      content={
        <>
          <div className="row mb-3">
            <div className="col-sm-6">
              <CustomInput
                required
                asterisk
                label="Name"
                placeholder="Enter Name"
                type="text"
                name="name"
                value={formValues.name}
                onChange={(e) => handleInputChange("name", e)}
                disabled={modalContentState === "View"}
                style={{ borderRadius: "4px" }}
              />
            </div>

            <div className="col-sm-6">
              <CustomInput
                label="Short Code"
                placeholder="Enter Short Code"
                type="text"
                name="shortcode"
                value={formValues.shortcode}
                onChange={(e) => handleInputChange("shortcode", e)}
                disabled={modalContentState === "View"}
                style={{ borderRadius: "4px" }}
              />
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-sm-12">
              <ReusableDropdown
               asterisk
                DropdownHeading="Organization Unit"
                options={formattedOrgUnitData || []}
                onChange={(value: any) =>
                  handleDropdownSelect("orgunit", value)
                }
                value={formValues?.orgunit || selectedRowData?.OrgUnitId}
                isDisabled={modalContentState === "View"}
              />
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-sm-12">
              <ReusableDropdown
                asterisk
                DropdownHeading="Currency"
                options={formattedCurrenciesData || []}
                onChange={(value: any) =>
                  handleDropdownSelect("currency", value)
                }
                value={formValues?.currency || selectedRowData?.CurrencyId}
                isDisabled={modalContentState === "View"}
              />
            </div>
          </div>

          <div className="row mb-0">
            <div className="col-sm-6">
              <CustomInput
                asterisk
                required
                label="Start Date"
                type="date"
                placeholder="Enter Start Date"
                name="startdate"
                value={formValues.startdate}
                onChange={(e) => handleInputChange("startdate", e)}
                disabled={modalContentState === "View"}
                style={{ borderRadius: "4px" }}
              />
            </div>

            <div className="col-sm-6">
              <CustomInput
                asterisk
                required
                label="End Date"
                type="date"
                placeholder="Enter End Date"
                name="enddate"
                value={formValues.enddate}
                onChange={(e) => handleInputChange("enddate", e)}
                disabled={modalContentState === "View"}
                style={{ borderRadius: "4px" }}
              />
            </div>
          </div>

          {/* Buttons */}
          {modalContentState === "View" ? (
            <></>
          ) : (
            <div className="d-flex justify-content-start gap-2">
              <Btn
                style={{ backgroundColor: "#43B9B2", color: "white" }}
                type="submit"
                // onClick={() => handleSubmit(formValues)}
                onClick={() => handleSubmitInsideChild(formValues)}
              >
                Submit
              </Btn>
              <Btn
                style={{
                  backgroundColor: "#F9FAFC",
                  color: "#000",
                  border: "1px solid #E0E0E0",
                }}
                type="button"
                onClick={onCancilBtn}
              >
                Cancel
              </Btn>
            </div>
          )}
        </>
      }
    />
  );
};

export default CommonModalForNewPolicy;
